
const smoothScroll = {
    scrollTo: (el, _offset) => {
        var dT = 1/30
        if (!el) { return "failed" }
        var offset = el.offsetTop + _offset;
        var x;
        var x_0 = window.scrollY;
        var D = offset-window.scrollY;
        var t = 0;
        var T = 0.5; // total time in seconds
        function dit () {
            x = x_0 + D*(0.5-0.5*Math.cos(3.14/T*t));
            t += dT;
            window.scrollTo(0,x);
            if (t < T) {
                requestAnimationFrame(dit);
            }
        }
        dit();
    },
    scrollToOffset: offset => {
        var dT = 1/30
        var x;
        var x_0 = window.scrollY;
        var D = offset-window.scrollY;
        var t = 0;
        var T = 0.5; // total time in seconds
        function dit () {
            x = x_0 + D*(0.5-0.5*Math.cos(3.14/T*t));
            t += dT;
            window.scrollTo(0,x);
            if (t < T) {
                requestAnimationFrame(dit);
            }
        }
        dit();
    }

}

export default smoothScroll



// WEBPACK FOOTER //
// ./src/util/smoothScroll.js